import { render, staticRenderFns } from "./DispensationEscalations.vue?vue&type=template&id=66fbed87&scoped=true&"
import script from "./DispensationEscalations.vue?vue&type=script&lang=js&"
export * from "./DispensationEscalations.vue?vue&type=script&lang=js&"
import style0 from "./DispensationEscalations.vue?vue&type=style&index=0&id=66fbed87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fbed87",
  null
  
)

export default component.exports